// import 'https://bdc.bqjr.cn/script/common/xw.1.0.min.js';
function joinXW(url) {
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = url;
  document.querySelector("head").appendChild(s);
}
export default {
  behavior: {
    params: {},
    cacheKey: ['utm_source', 'utm_medium', 'utm_campaign', 'mobile', 'customer_id', 'open_id', 'module_id'],
    cacheData: {}
  },
  sessionKey: 'behaviorParmas',

  initSrc: function () {
    joinXW('https://bdc.bqjr.cn/script/common/xw.1.0.min.js');
    joinXW("https://bdc.bqjr.cn/script/common/behaviorData.js");
    joinXW('https://bdc.bqjr.cn/script/BQMMQB/conf.js');
  },

  /**
   *初始化执行
   */
  init: function () {
    var _self = this;
    // console.log('my_openid: ',_self.GetQueryString('openId'));
    // _self.behavior.params['enterPageTime'] = _self.fmDate(new Date(), "yyyy-MM-dd hh:mm:ss"); //记录用户进入时间
    // 如果链接后面带有埋点参数,则在链接后面取
    if (_self.GetQueryString('utm_source')) {
      for (var i = 0; i < _self.behavior.cacheKey.length; i++) {
        var key = _self.behavior.cacheKey[i],
          value = _self.GetQueryString(key) ? _self.GetQueryString(key) : '';
        _self.behavior.params[key] = value;
        _self.behavior.cacheData[key] = value;
      }
      sessionStorage.setItem(_self.sessionKey, JSON.stringify(_self.behavior.cacheData));
    } else {
      _self.getSessionParmas();
    }
  },

  /**
   * 触发埋点请求
   */
  send: function (eventName, eventCode, data) {

    var _self = this;
    var dataTmp = {};
    dataTmp['behavior_type'] = eventCode;
    // dataTmp['enterPageTime'] = _self.behavior.params.enterPageTime;
    for (var k in _self.behavior.cacheData) {
      dataTmp[k] = _self.behavior.cacheData[k];
    }
    for (var p in data) {
      dataTmp[p] = data[p];
    }
    try {
      // xw.sendData(eventName, eventCode, dataTmp);
    } catch (error) {
      console.log('埋点报错');
    }
  },

  /**
   * 在缓存中获取埋点数据
   */
  getSessionParmas: function () {
    var _self = this;
    var bParmas = sessionStorage.getItem(_self.sessionKey);
    if (bParmas) {
      _self.behavior.cacheData = JSON.parse(bParmas);
    }
  },

  /**
   * 重新更新储存在缓存里面的数据
   */
  updateParams: function (objs) {
    var _self = this;
    _self.getSessionParmas();
    for (var i = 0; i < objs.length; i++) {
      var key = objs[i].key,
        val = objs[i].val;
      _self.behavior.cacheData[key] = val;
    }

    sessionStorage.setItem(_self.sessionKey, JSON.stringify(_self.behavior.cacheData));
  },

  /**
   * 获取链接后面的参数
   */
  GetQueryString: function (strname) {
    let url = window.location.href;
    let _pa = url.substring(url.indexOf('?') + 1),
      _arrS = _pa.split('&'),
      _rs = {};
    for (let i = 0, _len = _arrS.length; i < _len; i++) {
      let pos = _arrS[i].indexOf('=');
      if (pos == -1) {
        continue;
      }
      let name = _arrS[i].substring(0, pos),
        value = window.decodeURIComponent(_arrS[i].substring(pos + 1));
      _rs[name] = value;
    }
    return _rs[strname];
  },
  // /**
  //  * 获取链接后面的参数
  //  */
  // GetQueryString: function (strname) {
  //   var reg = new RegExp("(^|&)" + strname + "=([^&]*)(&|$)");
  //   var r = window.location.search.substr(1).match(reg);
  //   if (r != null) return decodeURIComponent(r[2]);
  //   return null;
  // },

  /**
   * 获取时间格式
   */
  fmDate: function (date, fmt) {
    var o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },

  /**
   * 在链接后面加上之前埋点的参数
   */
  generatorQueryStr: function (link) {
    var _self = this;
    var keys = _self.behavior.cacheKey,
      data = _self.behavior.cacheData,
      queryStr = ''

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i],
        value = data[key] ? data[key] : '';
      queryStr += '&' + key + '=' + value;
    }
    if (link.indexOf('?') == -1) {
      queryStr = '?' + queryStr.substr(1);
    }
    link += queryStr;

    return link;
  },

  stopShare:() => {
    document.addEventListener('WeixinJSBridgeReady', function() {
        // 通过下面这个API隐藏右上角按钮
        WeixinJSBridge.call('hideOptionMenu');
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/utils.js